import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=39aa006e&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=39aa006e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa006e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39aa006e')) {
      api.createRecord('39aa006e', component.options)
    } else {
      api.reload('39aa006e', component.options)
    }
    module.hot.accept("./app-header.vue?vue&type=template&id=39aa006e&scoped=true&", function () {
      api.rerender('39aa006e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-header/app-header.vue"
export default component.exports